<template>
    <div>
        <div>
            <Title
                class="md:block md:mt-4 md:mb-4"
                text="請確認輸入的資料"
                style-code-page
            />
            <div class="min-h-[30vh]">
                <!-- <div v-if="!hasData">
                        <SkeletonConfirmData />
                    </div>
                    <div v-else> -->
                <!-- <SkeletonConfirmData /> -->
                <A3Data />
                <!-- </div> -->
            </div>
        </div>
        <Loading :is-loading="isLoading" />
        <!-- 門號核實 -->
        <!-- <ModalMobileVerify
            v-model:postApiMid="postApiMid"
            @confirm="confirmApiMid"
        /> -->
    </div>
</template>

<script>
import { ref } from 'vue';
import Title from '@/components/text/Title.vue';
import Loading from '@/components/Loading.vue';
// import SkeletonConfirmData from '@/components/skeletons/SkeletonConfirmData.vue';
import A3Data from './A3Data.vue';

export default {
    components: {
        A3Data,
        Title,
        Loading,
        // SkeletonConfirmData
    },
    setup() {
        const isLoading = ref(false);
        return { isLoading };
    },
};
</script>
